/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Info_Att_TitleInputs */

const en_mobile_info_att_title = /** @type {(inputs: Mobile_Info_Att_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalized Experience, Just for You`)
};

const es_mobile_info_att_title = /** @type {(inputs: Mobile_Info_Att_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experiencia personalizada, solo para ti`)
};

/**
* | output |
* | --- |
* | "Personalized Experience, Just for You" |
*
* @param {Mobile_Info_Att_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_info_att_title = /** @type {((inputs?: Mobile_Info_Att_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Info_Att_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_info_att_title(inputs)
	return en_mobile_info_att_title(inputs)
});